/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
  // newImageSrc is the path of the new image in the same size as originalImage is sized.
  // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
  // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
  jQuery(mainImageDomEl).parents('a').attr('href', newImageSrc.replace('_grande', '_1024x1024'));
  jQuery(mainImageDomEl).attr('src', newImageSrc);  
};

jQuery(function($) {
                    
  /* Placeholder JS */
  /*==========================*/
  var test = document.createElement('input');
  if (!('placeholder' in test)) {
    $('[placeholder]').each(function(){
      if ($(this).val() === '') {
        var hint = $(this).attr('placeholder');
        $(this).val(hint).addClass('hint');
      }
    });
    $('[placeholder]').focus(function() {
      if ($(this).val() === $(this).attr('placeholder')) {
        $(this).val('').removeClass('hint');
      }
    }).blur(function() {
      if ($(this).val() === '') {
        $(this).val($(this).attr('placeholder')).addClass('hint');
      }
    });    
  }

  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });
  
  /* Update main product image when a thumbnail is clicked. */
  /*==========================*/
  $('.product-photo-thumb a').on('click', function(e) { 
    e.preventDefault();
    switchImage($(this).attr('href'), null, $('.product-photo-container img')[0]);
  } );
  
});

$(document).ready(function(){
  $('.product-container li').hover(function () {
      $(this).find('.second-image').addClass('fade-on');
      $(this).find('.first-image').addClass('fade-off');
    }, function() {
      $(this).find('.second-image').removeClass('fade-on');
      $(this).find('.first-image').removeClass('fade-off');
    });
});  

$(document).ready(function(){
  $('.spin-container').hover(function () {
      $(this).addClass('spin');
    }, function() {
      $(this).removeClass('spin');

    });
});

$(document).ready(function(){
  $( ".spin-container , .nav-container ul li" ).click(function() {   
    $( ".nav-list" ).fadeToggle();
  });
});

$(document).ready(function(){
  $('.st1').hover(function () {
      $("path.top").addClass("green");
    }, function() {
      $(".top").removeClass("green");
    });
});

$(document).ready(function(){
  $( ".close" ).click(function() {   
    $( ".sign-up-take-over" ).fadeToggle();
  });
});

$(document).ready(function(){
  $('#site-title').hover(function () {
      $(".logo-1").hide();
   	  $(".logo-2").show();
    }, function() {
      $(".logo-1").show();
   	  $(".logo-2").hide();
    });
});

$(document).ready(function(){
  $( ".search" ).click(function() {   
    $( ".search-form" ).toggle();
    $(".search").toggle();
    $(".search-close").toggle();
  });

  $( ".search-close" ).click(function() {   
    $( ".search-form" ).toggle();
    $(".search-close").toggle();
    $(".search").toggle();
  });
});
  
  
$(document).on('click', function(e) {
    if ( $(e.target).closest('.nav-toggle').length ) {
        $(".nav-list").show();
    }else if ( ! $(e.target).closest('.nav-list').length ) {
        $('.nav-list').fadeOut();
    }
});

$(document).ready(function(){
  $("img").on("load", function(event){
    scroll.update(event.currentTarget === this);
  });
});